module.exports = __webpack_public_path__ + "img/tsel.56c1eb29.png";